import React from 'react';

const Copyright = ({isBigScreen}) => {
    return (
        <p style={{fontSize: "14px"}}>© Copyright PT Paragon Technology and Innovation. All Rights Reserved.</p>
    );
};

export default Copyright;
